const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userInfo: state => state.user.userInfo,
  adminToken: state => state.user.adminToken
  // guideDialog: state => state.user.guideDialog
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js